module.exports = __webpack_public_path__ + "img/private-pizzeriano3-pizzas-3.51a0b03b.jpg";